/** Baut eine Checkbox-Zeile mit optionalem Farbmuster und Zähler. */
export function toggleRow({ id, label, note, swatch, dot, checked = true, onChange }) {
  const row = document.createElement('div');
  row.className = 'group__row';

  const wrap = document.createElement('label');
  wrap.className = 'toggle';

  const input = document.createElement('input');
  input.type = 'checkbox';
  input.checked = checked;
  input.dataset.id = id;
  input.addEventListener('change', () => onChange?.(input.checked, input));

  const box = document.createElement('span');
  box.className = 'toggle__box';

  wrap.append(input, box);

  if (swatch) {
    const sw = document.createElement('span');
    sw.className = 'swatch';
    sw.style.background = swatch;
    wrap.append(sw);
  }
  if (dot) {
    const d = document.createElement('span');
    d.className = 'dot';
    d.style.background = dot;
    wrap.append(d);
  }

  const text = document.createElement('span');
  text.className = 'toggle__label';
  text.textContent = label;
  wrap.append(text);

  if (note) {
    const n = document.createElement('span');
    n.className = 'toggle__note';
    n.textContent = note;
    wrap.append(n);
  }

  row.append(wrap);
  return { row, input };
}

export function expandButton(expanded, onToggle) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'group__expand';
  btn.setAttribute('aria-expanded', String(expanded));
  btn.title = 'Unterfilter anzeigen';
  btn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3.5l5 4.5-5 4.5"/></svg>';
  btn.addEventListener('click', () => {
    const next = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(next));
    onToggle(next);
  });
  return btn;
}

export function counter() {
  const el = document.createElement('span');
  el.className = 'count';
  return el;
}
